var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBidUpIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 450 612.1",
    style: {
      enableBackground: "new 0 0 450 612.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#A8D3D8;}\n\t.st1{fill:#7CA1B1;}\n\t.st2{fill:#00C213;}\n\t.st3{fill:#00870D;}\n\t.st4{fill:#DEECF1;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M255,400.1v197c0,8.4-6.6,15-15,15h-30c-8.4,0-15-6.6-15-15v-197H255z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M255,400.1v197c0,8.4-6.6,15-15,15h-15v-212H255z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M450,15v370.1c0,8.4-6.6,15-15,15H15c-8.4,0-15-6.6-15-15V15C0,6.6,6.6,0,15,0h420C443.4,0,450,6.6,450,15z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M450,15v370.1c0,8.4-6.6,15-15,15H225V0h210C443.4,0,450,6.6,450,15z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M240,185.1v120c0,8.4-6.6,15-15,15s-15-6.6-15-15v-120c0-8.4,6.6-15,15-15S240,176.7,240,185.1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M180,215.1c0-24.8-20.2-45-45-45h-30c-8.3,0-15,6.7-15,15v120c0,8.3,6.7,15,15,15h30c24.8,0,45-20.2,45-45 c0-11.6-4.5-22-11.7-30C175.5,237.1,180,226.7,180,215.1z M120,200.1h15c8.3,0,15,6.7,15,15s-6.7,15-15,15h-15V200.1z M135,290.1 h-15v-30h15c8.3,0,15,6.7,15,15S143.3,290.1,135,290.1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M315,320.1h-30c-8.3,0-15-6.7-15-15v-120c0-8.3,6.7-15,15-15h30c24.8,0,45,20.2,45,45v60 C360,299.9,339.8,320.1,315,320.1z M300,290.1h15c8.3,0,15-6.7,15-15v-60c0-8.3-6.7-15-15-15h-15V290.1z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M225,320.1v-150c8.4,0,15,6.6,15,15v120C240,313.5,233.4,320.1,225,320.1z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M315,370.1H135c-8.4,0-15,6.6-15,15v30c0,8.4,6.6,15,15,15h180c8.4,0,15-6.6,15-15v-30 C330,376.7,323.4,370.1,315,370.1z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M330,385.1v30c0,8.4-6.6,15-15,15h-90v-60h90C323.4,370.1,330,376.7,330,385.1z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M214.2,54.5l-44,55.7c-2,2.6-3.1,5.2-3.1,7.3c0,4.2,3.9,6.7,10.3,6.7h95.2c6.5,0,10.3-2.6,10.3-6.7 c0-2.2-1.1-4.7-3.1-7.3l-44-55.7c-2.8-3.6-6.7-5.6-10.8-5.6C220.9,48.9,217.1,50.9,214.2,54.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBidUpIcon);
export default __webpack_public_path__ + "static/media/bid_up_icon.b8e0ef4b706099c3c6e99fb0668a18d0.svg";
export { ForwardRef as ReactComponent };